import styled from 'styled-components/macro';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';
import Section from '../Section';
import TitledContent from '../TitledContent';

export const CompanyContactsSection = styled(Section)`
  padding-top: 25px;
  padding-bottom: 25px;
  padding-left: 15px;
  padding-right: 30px;
  > h2 {
    ${fontSize(14)};
    line-height: 1.29;
    font-weight: bold;
  }
  ${media.desktop`
    padding-top: 40px;
    padding-bottom: 40px;
    padding-right: 45px;
    padding-left: 45px;
    > h2 {
      ${fontSize(18)};
      line-height: 1.33;
    }
  `}
`;

export const ContactTitledContent = styled(TitledContent)`
  justify-content: space-between;

  > p {
    ${fontSize(14)};
  }
  ${media.desktop`
    > label {
      ${fontSize(16)};
      line-height: 1.5;
    }
    > p {
      ${fontSize(18)};
    }
  `}
`;
